import React, {useEffect, useContext, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedSymbol, setSymbolList, setInterval, setStartDate, setEndDate, setDateRangeChanged, setPageLoaded, setDaysPreSet } from '../pages/slices/entryPanelSlicer';
// import Select from 'react-select';
import axios from 'axios';
import DataPicker from './DataPicker'; 
import CustomSelect from './CustomSelect'; 
import styles from './EntryPanel.module.css'
import { CsrfTokenContext } from '../CsrfTokenContext';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
    
const EntryPanel = () => {  

  const csrfToken = useContext(CsrfTokenContext);  

  const dispatch = useDispatch();
  const { pageLoaded, selectedSymbol, symbolList, interval, startDate, endDate, daysPreSet } = useSelector(state => state.entryPanel);
  const { symbolLimit } = useSelector(state => state.globalData);
  // const [plotError, setPlotError] = useState('');
  
  const refreshTokenIfNeeded = useCallback(async () => {
    if (isTokenExpired()) {        
      await handleLogin();
    }    
  },[]);
  
  useEffect(() => {
        
    // if(!pageLoaded){
        const fetchIcons = async () => {
            
            // if(symbolList.length > 0) return;
            
            try {

              await refreshTokenIfNeeded();
                        
                const response = await axios.get(`/api/symbols?limit=${symbolLimit}`, {
                  method: 'GET',
                  // credentials: 'include',
                  headers: {                    
                      'Content-Type': 'application/json',
                      'X-CSRFToken': csrfToken
                  }
              });
                const serializedData = response.data.map((option) => ({
                    "value": option.symbol_name,
                    "label": {
                      "symbol_icon": option.symbol_icon,
                      "symbol_name": option.symbol_name,
                      "ranking": option.ranking
                    },
                    'symbol_icon': option.symbol_icon,
                    'ranking': option.ranking
                }));                
          
                dispatch(setSymbolList(serializedData));
                dispatch(setPageLoaded(true));
            } catch (error) {
                console.error('Error fetching crypto icons:', error);
            }
        };

        fetchIcons();
    // }
    
}, [pageLoaded, dispatch, symbolList.length, daysPreSet, csrfToken, symbolLimit, refreshTokenIfNeeded]);  
  
  const handleChange = (selectedOption) => {       
    const symbolSel = {'value':selectedOption.value, 'symbol_icon': selectedOption.symbol_icon, 'ranking':selectedOption.ranking}        
    dispatch(setSelectedSymbol(symbolSel));            
    // setPlotError(null);
  };    
  
  const handleIntervalChange = (event) => {                    
    dispatch(setInterval(event)); 
    if(interval && Object.keys(selectedSymbol).length !== 0 && startDate !== '' && endDate !== ''){
        //Enable plot controls ?
    }    
  };

  const handleDaysPreSet = (days) => {
    dispatch(setStartDate(''));
    dispatch(setEndDate(''));    
    dispatch(setDaysPreSet(days));      
  };

  const handleStartDateChange = (date) => {    
    dispatch(setDaysPreSet(0));            
    dispatch(setStartDate(date.toDateString()));
    if(interval && Object.keys(selectedSymbol).length !== 0 && endDate){            
         //Enable plot controls ?
    }    
    dispatch(setDateRangeChanged(true));
    dispatch(setEndDate(''));    
    // setPlotError(null);
  };

  const handleSelectedDate = (dateStr) => {    
    const result = endDate!=='' ? new Date(dateStr) : null;    
    return result;           
  };

  const handleEndDateChange = (date) => {        
    dispatch(setEndDate(date.toDateString()));    
    dispatch(setDaysPreSet(0));      
    if(interval && Object.keys(selectedSymbol).length !== 0 && startDate !== ''){            
         //Enable plot controls ?
    }    
    dispatch(setDateRangeChanged(true));
  };

  const getMinDate = (numDays) =>{
        
    // Get the current date
    const now = new Date();

    // Subtract the period (number of days)
    const pastDate = new Date(now.setDate(now.getDate() - numDays));

    // Format the date as 'YYYY-MM-DD'
    const year = pastDate.getFullYear();
    const month = String(pastDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(pastDate.getDate()).padStart(2, '0');
    
    return new Date(year, month-1, day);;
  }

  const addDays = (date, days) => {
      const result = new Date(date); // Create a new Date object based on the given date
      result.setDate(result.getDate() + days); // Add the specified number of days
      return result;
  };

  // const formatDate = (date) => {
  //     const result = new Date(date);
  //     const year = result.getFullYear();
  //     const month = String(result.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  //     const day = String(result.getDate()).padStart(2, '0');
  //     return `${year}-${month}-${day}`;
  // };

  const minDate = getMinDate(725);
  const maxDate = addDays(new Date(), 0); // -30
  
  return (
    <div className='scrollableContainer'>
    <table style={{width:'100%', paddingTop:'20px'}}>
        <tbody>
            <tr>
                <td>
                    <fieldset className={styles.fieldset}>
                        <legend className={styles.legend}>Available Symbols</legend>
                        <div className={styles.select_container}>                   
                            <CustomSelect handleChange={handleChange} selectedOption={selectedSymbol} />
                        </div>
                    </fieldset>
                </td>
                <td>                                    
                    <fieldset className={styles.fieldset}>
                        <legend className={styles.legend}>Select Interval</legend>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)'}}>
                            <div className={`${styles.radio_container} ${interval === '1h' ? styles.selected : ''}`} onClick={() => handleIntervalChange('1h')} >
                                1 hour
                            </div>
                            <div className={`${styles.radio_container} ${interval === '4h' ? styles.selected : ''}`} onClick={() => handleIntervalChange('4h')} >
                                4 hours
                            </div>
                            <div className={`${styles.radio_container} ${interval === '1d' ? styles.selected : ''}`} onClick={() => handleIntervalChange('1d')} >
                                1 day
                            </div>
                            <div className={`${styles.radio_container} ${interval === 'W' ? styles.selected : ''}`} onClick={() => handleIntervalChange('W')} >
                                1 week
                            </div>
                        </div>
                    </fieldset>
                </td>
                <td>                                    
                <fieldset className={styles.fieldset}>
                      <legend className={styles.legend}>Days</legend>
                      <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)'}}>
                        <div className={`${styles.radio_container} ${daysPreSet === 30 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(30)} >
                            30
                        </div>
                        <div className={`${styles.radio_container} ${daysPreSet === 60 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(60)} >
                            60
                        </div>
                        <div className={`${styles.radio_container} ${daysPreSet === 90 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(90)}>
                            90
                        </div>
                        <div className={`${styles.radio_container} ${daysPreSet === 120 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(120)} >
                            120
                        </div>
                        <div className={`${styles.radio_container} ${daysPreSet === 180 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(180)} >
                            180
                        </div>
                        <div className={`${styles.radio_container} ${daysPreSet === 270 ? styles.selected : ''}`} onClick={() => handleDaysPreSet(270)} >
                            270
                        </div>
                      </div>
                  </fieldset>
                </td>
                <td > 
                    <fieldset className={styles.fieldset} style={{height:'50px', textAlign:'center'}}>
                        <legend className={styles.legend}>Start Date</legend>
                        <DataPicker minDate={minDate} maxDate={addDays(maxDate, -30)} onDateChange={handleStartDateChange} selectedDate={handleSelectedDate(startDate)}/>
                    </fieldset>

                    <fieldset className={styles.fieldset} style={{height:'50px', textAlign:'center'}}>
                        <legend className={styles.legend}>End Date</legend>
                        <DataPicker disabled = {startDate===''} minDate={addDays(startDate, 30)} maxDate={maxDate} onDateChange={handleEndDateChange} selectedDate={handleSelectedDate(endDate)}/>
                    </fieldset>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
  );
}

export default EntryPanel;